<template>
  <template-info :bgImg="bgImg" title="ทำไมต้องจด VAT">
    <div>
      <div class="wraps-content">
        1. <span class="contents"><span class="bold">ถูกกฎหมาย</span></span>
      </div>
      <div class="wraps-content">
        2.
        <span class="contents"
          >ตามกฎหมายคุณจะต้องจัดทำและเก็บเอกสารรายการซื้อ-ขาย ทำให้เรา<span
            class="bold"
            >มีระบบการเก็บรวบรวม ข้อมูลการค้าดีขึ้น</span
          ></span
        >
      </div>
      <div class="wraps-content">
        3.
        <span class="contents"
          ><span class="bold">ดูน่าเชื่อถือ</span> เพิ่มโอกาสในการทำธุรกิจ
          เวลาไปขายของแล้วลูกค้าอยากได้ใบกำกับภาษี
          คุณก็สามารถออกให้เค้าได้อย่างเต็มภาคภูมิ</span
        >
      </div>
      <chevron-right-link
        style="margin-top: 9px;"
        @clickLink="goVatCondition"
        caption="เราต้องจด VAT เมื่อไหร่"
      />
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/vat_benefit.png";

export default {
  name: "VatBenefit",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
  methods: {
    goVatCondition() {
      this.$router.push({
        path: "/info/vat_condition",
      });
    },
  },
};
</script>
<style scoped>
.wraps-content {
  display: flex;
  margin-bottom: 10px;
}
.contents {
  margin-left: 13px;
}
.bold {
  font-weight: bold;
}
</style>
